module.exports = __webpack_public_path__ + "assets/team-left.440094b3.svg";